import { ElementRef } from '@angular/core';
import { Content, ToastController, AlertController, Platform, NavController } from 'ionic-angular';
// import { PhotoLibrary } from '@ionic-native/photo-library';
import { PhotoLibrary } from './../../providers/my-photo-library';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { CallNumber } from '@ionic-native/call-number';
import Utils from '../../_com/utils';
import _ from 'underscore';

/**
 * 「食べたことがある」食材マスタ
 * NOTE: 配列の順序がそのまま表示順になる(キーの昇順ではない)
 */
export const TABETAKOTOARU_FOOD_LIST = [
  {key: 1, value:"卵"},
  {key: 2, value:"乳"},
  {key: 3, value:"小麦"},
  {key: 4, value:"ごま"},
  {key: 5, value:"大豆"},
  {key: 13, value: "牛肉"},
  {key: 12, value: "豚肉"},
  {key: 11, value: "鶏肉"},
  {key: 10, value: "さけ"},
  {key: 9, value:"さば"},
  {key: 18, value: "あじ"},
  {key: 16, value: "さわら"},
  {key: 15, value: "たら"},
  {key: 17, value: "ぶり"},
  {key: 6, value:"オレンジ"},
  {key: 8, value:"リンゴ"},
  {key: 7, value:"バナナ"},
  {key: 14, value: "ゼラチン"},
  {key: 99, value: "すべて食べたことがある"},
];

/**
 * あじ のキー
 * NOTE: 99「すべて食べたことがある」より後に追加した項目のため、
 *       99 が登録済みでも あじ は未確認(未食)として扱う
 */
export const TABETAKOTOARU_FOOD_KEY_AJI = "18";

/**
 * Generated class for the ElderlyChooser page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
export abstract class AbstractPage {
  _Utils = Utils;
  _el: HTMLElement;
  constructor() {}

  /**
   * コンテンツスクロールトップ
   */
  scrollTop(content: Content): void {
    if (_.isUndefined(content)) return;
    if (_.isNull(content["_scroll"])) return;
    if (typeof content.scrollToTop !== "function") return;
    content.scrollToTop(1000);
  }

  /**
   * コンテンツスクロール
   */
  scrollTo(content: Content, elementId: string) {
    let yOffset = document.getElementById(elementId).offsetTop - 10;
    content.scrollTo(0, yOffset, 500);
  }

  /**
   * NativeElementを設定する
   */
  readyDomAccess(el: ElementRef) {
    this._el = el.nativeElement;
  }

  /**
   * NavController.setRoot() をラップし、トランジションを追加する
   */
  setRoot(
    navController: NavController,
    component: any,
    directionForward: boolean = true
  ) {
    var direction = directionForward ? "forward" : "back";
    navController.setRoot(
      component,
      {},
      {
        animate: true,
        animation: "ios-transition",
        direction: direction,
        duration: 200,
        easing: "ease-out",
      }
    ); //次画面遷移
  }

  /**
   * 画面側で必須チェックの値判定
   */
  isValidRequired(d) {
    return d;
  }

  /**
   * 画面内項目に .requiredError のエラーが付与されているか否かの判定
   */
  hasInvalidRequired() {
    if (!this._el) return true;
    return this._el.querySelectorAll(".requiredError").length > 0;
  }

  /**
   * 画面内項目に .ng-touched が付与されているか否かの判定
   */
  hasTouched() {
    if (!this._el) return true;
    return this._el.querySelectorAll(".ng-touched").length > 0;
  }

  /**
   * 写真表示
   */
  showPhoto(
    url,
    photoLibrary: PhotoLibrary,
    photoViewer: PhotoViewer,
    platform: Platform
  ) {
    if (!url) return;

    // TODO: 下記の条件に当てはまる処理が動いていないため一旦コメントアウト
    // 本家のphotoLibraryがswift3でしか動かないので独自に「plugins-dev/plugin-my-photo-library」を作成
    // 上記ファイルは一旦空になっているので、必要になれば権限を取得するための処理を記載する必要がある点に注意
    // console.log('platform.platforms()', platform.platforms());
    // if((!platform.is("mobileweb")) && (!platform.is("core"))){
    //   photoLibrary.requestAuthorization().then(() => {
    //     photoViewer.show(url);
    //   });
    // }
  }

  /**
   * トースター起動
   */
  toast(t: ToastController, message: string, options?: object) {
    t.create({
      message: message,
      duration: 3000,
      position: "top",
      showCloseButton: true,
      closeButtonText: "OK",
    }).present();
  }

  /**
   * ダイアログ起動
   */
  alert(alertCtrl: AlertController, message: string) {
    let alert = alertCtrl.create({
      title: "通知",
      subTitle: message,
      buttons: ["OK"],
    });
    alert.present();
  }

  /**
   * 確認ダイアログ起動
   */
  confirm(
    alertCtrl: AlertController,
    message: string,
    successHandler: Function
  ) {
    let confirm = alertCtrl.create({
      title: "確認",
      message: message,
      buttons: [
        {
          text: "いいえ",
          handler: () => {
            console.log("Disagree clicked");
          },
        },
        {
          text: "はい",
          handler: () => {
            successHandler();
            console.log("Agree clicked");
          },
        },
      ],
    });
    confirm.present();
  }

  /**
   * 電話をかける
   */
  call(callNumber: CallNumber, tel: string) {
    if (!callNumber || !tel) return;

    callNumber
      .callNumber(tel, true)
      .then(() => console.log("Launched dialer!"))
      .catch(() => console.log("Error launching dialer"));
  }

  /**
   * 名称を取得する
   */
  getName(data) {
    if (!data) return;

    if (data["name"]) {
      return data["name"];
    }
    return data["kana"];
  }

  /**
   * カナ名称を取得する
   */
  getKanaName(data) {
    if (!data) return;

    if (data["kana"]) {
      return data["kana"];
    }
    return data["name"];
  }

  /**
   * 選択されている食材名を繋げた値を取得する
   *
   * @param data
   * @param isReverse true: 食べたことがないを表示する
   * @returns
   */
  getFoodNames(data, isReverse = false) {
    // データがない場合は、から配列を定義しておく
    if (!data) data = [];

    // 全食材を食べたことがある場合のみ、まとめて表示する
    if (this.isAllTabetakotoaruFoods(data)) {
      return isReverse ? "-" : "すべて食べたことがある";
    }

    // 99: すべて食べたことがある (旧データ)
    // NOTE: あじ は 99 より後に追加した項目のため未確認(未食)として扱う必要があり、
    //       まとめずに個別の食材名を表示する
    const isAllTabetakotoaru = !!data.find(key => key == "99");

    // 表示する順序
    let FOOD_LIST = TABETAKOTOARU_FOOD_LIST;

    var result = "";
    FOOD_LIST.forEach(food => {
      const index = food["key"];
      if (index === 99) return;
      const foodName = food["value"];

      // NOTE: 文字列と数値の比較
      // あじ は 99 より後に追加した項目のため、99 でも未確認(未食)として扱う
      const isTabetakotoaru = (isAllTabetakotoaru && String(index) !== TABETAKOTOARU_FOOD_KEY_AJI)
        || !!data.find(key => key == index);

      let text = "";
      if (isReverse) {
        // 食べたことがないを求める
        if (!isTabetakotoaru) {
          text = foodName;
        }
       } else {
        // 食べたことがあるを求める
        if (isTabetakotoaru) {
          text = foodName;
        }
      }
      if (text) {
        result += result == "" ? "" : "\n";
        result += text;
      }
    });
    return result;
  }


  /**
   * 離乳食の食材 を抽出する
   *
   * @param data
   * @param isReverse 食べたことがある、ないで表示を切り替えるフラグ(false: 食べたことがある)
   * @returns
   */
  getRinyushokuFoodNames(data: string[], isReverse = false) {
    if (!data || data.length === 0) return "-";

    if (data.includes && data.includes("all")) {
      // 「食べたことがない」を表示する欄で、「すべて食べた」を選択されている場合は、食べたことがない食材は無いことになるので表示しない
      if (isReverse) {
        return "-";
      }
      return "すべて食べたことがある";
    }

    let FOOD = {
      jagaimo: "じゃがいも",
      ninjin: "人参",
      // aona: "青菜",
      komatusna: "小松菜",
      horenso: "ほうれん草",
      tamanegi: "玉ねぎ",
      kyabetsu: "キャベツ",
      banana: "バナナ",
      sasami: "ささみ",
      tofu: "豆腐",
      tara: "タラ",
      tuna: "シーチキン",
      fu: "お麩",
      shoyu: "醤油",
      miso: "味噌",
      shio: "塩",
      dashi: "ダシ（鰹昆布）",
      udon: "うどん",
      katakuriko: "片栗粉",
    };

    let target = [];
    if (isReverse) {
      //食べたことが「ない」を求める（データ表示を逆転させる）
      let foods = Utils.clone(FOOD);
      for (const key of data) {
        delete foods[key];
      }
      target = _.keys(foods);
    } else {
      //食べたことが「ある」を求める
      target = data;
    }

    return target.map((key) => FOOD[key]).join("\n");
  }


  /**
   * 離乳食の進み具合 ごはん の名称を返す
   */
  getRinyusyokuOkayuName(data) {
    if (!data) return "";
    switch (data) {
      case "F":
        return "普通のご飯";
      case "N":
        return "軟飯";
      case "5":
        return "５倍がゆ";
      case "7":
        return "７倍がゆ";
      case "10":
        return "１０倍がゆ";
    }
    return "";
  }

  /**
   * 離乳食の進み具合 野菜などの形状 の名称を返す
   */
  getKeijyoYasaiName(data) {
    if (!data) return "";
    switch (data) {
      case "1":
        return "幼児食(1⼝大)";
      case "2":
        return "幼児⾷(刻み)";
      case "3":
        return "後期 (1cm角)";
      case "4":
        return "中期（みじん切り）";
      case "5":
        return "初期（すりおろし）";
    }
    return "";
  }



  convertDateTime(data) {
    if (!data) return "-";
    return (
      this._Utils.date.format(new Date(data[0]), "HH:mm") +
      " - " +
      this._Utils.date.format(new Date(data[1]), "HH:mm")
    );
  }

  refleshTimeData(child) {
    if (!child) return;
    if (!!child["seikatsu_rizumu_kisho"]) {
      child["seikatsu_rizumu_kisho"] = new Date(child["seikatsu_rizumu_kisho"]);
    }
    if (!!child["seikatsu_rizumu_breakfast"]) {
      child["seikatsu_rizumu_breakfast"] = new Date(
        child["seikatsu_rizumu_breakfast"]
      );
    }
    if (!!child["seikatsu_rizumu_lunch"]) {
      child["seikatsu_rizumu_lunch"] = new Date(child["seikatsu_rizumu_lunch"]);
    }
    if (!!child["seikatsu_rizumu_oyatsu"]) {
      child["seikatsu_rizumu_oyatsu"] = new Date(
        child["seikatsu_rizumu_oyatsu"]
      );
    }
    if (!!child["seikatsu_rizumu_dinner"]) {
      child["seikatsu_rizumu_dinner"] = new Date(
        child["seikatsu_rizumu_dinner"]
      );
    }
    if (!!child["seikatsu_rizumu_sleep"]) {
      child["seikatsu_rizumu_sleep"] = new Date(child["seikatsu_rizumu_sleep"]);
    }
  }

  showKeyboard = false;
  // watchKeyboardEvent(keyboard:Keyboard, zone:NgZone){
  //   keyboard.onKeyboardShow().subscribe(data => {
  //     this.showKeyboard = true;
  //     zone.run(() => {});
  //   });
  //   keyboard.onKeyboardHide().subscribe(data => {
  //     this.showKeyboard = false;
  //     zone.run(() => {});
  //   });
  // }

  /**
   * @param
   * pickup: 入力された送迎情報
   * pickup_family_1:第１連絡先
   * pickup_family_2:第2連絡先
   * pickup_family_other: その他の連絡先
   * family: 家族情報
   * type：新規作成か編集か
   * othersInfo：その他の連絡先「名前」「電話番号」「続柄」
   *
   *
   */
  makePickupData(
    pickup,
    pickup_family_1,
    pickup_family_2,
    pickup_family_other,
    family,
    othersInfo
  ) {
    console.log("pickup", pickup);
    if (pickup_family_1) {
      // 第１連絡先
      pickup["pickup_Name"] = family["name"]; // 保護者名
      pickup["pickup_Name_kana"] = family["kana"]; // 保護者仮名
      pickup["tel"] = family["tel"]; // 保護者電話番号
      pickup["relation"] = ""; // 続柄
      pickup["type"] = "1"; // 第１連絡先
    } else if (pickup_family_2) {
      // 第2連絡先の場合
      pickup["pickup_Name"] = family["name2"]; // 保護者名
      pickup["pickup_Name_kana"] = ""; // 保護者仮名
      pickup["tel"] = family["tel2"]; // 第２連絡先電話番号
      pickup["relation"] = family["tel2_relation"]; // 続柄
      pickup["type"] = "2"; // 第2連絡先
    } else if (pickup_family_other) {
      // その他の連絡先の場合
      pickup["pickup_Name"] = othersInfo.name; // その他お迎え
      pickup["pickup_Name_kana"] = ""; // 保護者仮名
      pickup["tel"] = othersInfo.tel; // その他電話番号
      pickup["relation"] = othersInfo.relation; // その他電話番号
      pickup["type"] = "3"; // 第その他の連絡先
    }

    console.log("pickup", pickup);
    return pickup;
  }

  /**
   * MobileScroll Date オプション
   */
  mbscDateOptions: any = {
    display: "center",
    setOnDayTap: true,
    lang: "ja",
    animate: "fade",
    dateFormat: "yy/m/d(D)",
    firstSelectDay: 1,
    buttons: [
      // 'cancel',
      // {handler:"set", text:"反映する"}
    ],
  };
  /**
   * MobileScroll Date 複数選択オプション
   */
  mbscMultiDateOptions: any = {
    display: "center",
    setOnDayTap: true,
    lang: "ja",
    // TODO: 9/9 複数日予約登録がスタッフ側で対応しきれていないようだったので、もとに戻す
    controls: ['calendar','date'],
    animate: "fade",
    dateFormat: "yy/m/d(D)",
    firstSelectDay: 1,
    // TODO: 9/9 複数日予約登録がスタッフ側で対応しきれていないようだったので、もとに戻す
    select: 'multiple',
    buttons: [
      // TODO: 9/9 複数日予約登録がスタッフ側で対応しきれていないようだったので、もとに戻す
      'cancel',
      {handler:"set", text:"反映する"}
    ],
  };


  /**
   * MobileScroll Date オプション
   */
  mbscDateOptionsBirth: any = {
    display: "center",
    setOnDayTap: true,
    lang: "ja",
    animate: "fade",
    dateFormat: "yy/mm/dd",
    dateOrder: "ymd",
    firstSelectDay: 1,
    buttons: ["cancel", { handler: "set", text: "反映する" }],
  };

  /**
   * MobileScroll NUmpad Time オプション
   */
  mbscNumpadTimeOptions: any = {
    display: "center",
    lang: "ja",
    animate: "fade",
    timeFormat: "HH:ii",
    defaultValue: new Date(0, 0, 0, 9, 0),
    buttons: ["cancel", { handler: "set", text: "反映する" }],
    steps: {
      minute: 10,
      zeroBased: true,
    },
  };

  /**
   * MobileScroll NUmpad Time オプション
   * 予約のお迎え情報に使用
   */
  mbscNumpadTimeOptions2: any = {
    display: "center",
    lang: "ja",
    animate: "fade",
    timeFormat: "HH:ii",
    // defaultValue: new Date(0, 0, 0, 9, 0),
    buttons: ["cancel", { handler: "set", text: "反映する" }],
    steps: {
      minute: 5,
      zeroBased: true,
    },
  };

  /**
   * MobileScroll NUmpad Time オプション
   * 授乳関連の時間入力に活用
   */
  mbscNumpadTimeOptions3: any = {
    display: "center",
    lang: "ja",
    animate: "fade",
    timeFormat: "HH:ii",
    // defaultValue: new Date(0, 0, 0, 9, 0),
    buttons: ["cancel", { handler: "set", text: "反映する" }],
    steps: {
      minute: 15,
      zeroBased: true,
    },
  };


  /**
   * MobileScroll NUmpad Date オプション
   */
  mbscNumpadDateOptions: any = {
    display: "center",
    lang: "ja",
    animate: "fade",
    dateFormat: "yy/mm/dd",
    dateOrder: "ymd",
    buttons: ["cancel", "clear", { handler: "set", text: "反映する" }],
    leftKey: {
      text: "",
      variable: "",
      value: "",
    },
    rightKey: {
      text: "",
      variable: "",
      value: "",
    },
  };

  mbscRangeSettings: any = {
    theme: "ios",
    lang: "ja",
    display: "center",
    controls: ["time"],
    // maxWidth: 100
    buttons: ["cancel", { handler: "set", text: "反映する" }],
    // minRange: 31 * 60 * 1000,
    steps: {
      minute: 15,
      zeroBased: true,
    },
  };

  convertTime(data) {
    if (!data) return "-";
    return this._Utils.date.format(new Date(data), "HH:mm");
  }

  /**
   * 「食べたことある」食材のキーチェックを行う
   *
   * @
   * @param targetKey string ex) "1" "2"
   * @param tabetakotoaruFoods string[]  DB.chiledのtabetakotoaru_foods キー情報
   *
   */
  isTabetakotoaruFood(targetKey: string, tabetakotoaruFoods: string[] = []) {
    // 99: 全て食べたことがあるが 選択されている場合は、全て食べたことにする
    // NOTE: あじ は 99 より後に追加した項目のため、99 でも未確認(未食)として扱う
    if (tabetakotoaruFoods.includes("99") && targetKey !== TABETAKOTOARU_FOOD_KEY_AJI) {
      return true;
    }
    return tabetakotoaruFoods.find((key) => key === targetKey);
  }

  /**
   * 「食べたことある」食材の全キーを取得する(99: すべて食べたことがある は除く)
   */
  getAllTabetakotoaruFoodKeys(): string[] {
    return TABETAKOTOARU_FOOD_LIST
      .filter((food) => food["key"] !== 99)
      .map((food) => String(food["key"]));
  }

  /**
   * 全食材を食べたことがあるかを判定する
   */
  isAllTabetakotoaruFoods(tabetakotoaruFoods: string[] = []): boolean {
    if (!tabetakotoaruFoods || tabetakotoaruFoods.length === 0) return false;
    // NOTE: DBは文字列、マスタは数値のキーを持つため、あえて緩い比較を行う
    return this.getAllTabetakotoaruFoodKeys()
      .every((key) => !!tabetakotoaruFoods.find((value) => value == key));
  }

  /**
   * ion-select に表示するラベルを取得する
   *
   * 全食材を食べたことがある場合のみ「すべて食べたことがある」とまとめて表示する。
   * NOTE: 空文字を返すと ion-select 標準の「選択済みの項目名を連結した表示」になる
   */
  getTabetakotoaruFoodsSelectedText(tabetakotoaruFoods: string[] = []): string {
    return this.isAllTabetakotoaruFoods(tabetakotoaruFoods) ? "すべて食べたことがある" : "";
  }

  /**
   * 旧データの 99 を個別の食材キーへ展開する(編集画面の読み込み時に使用)
   *
   * 99 は「登録した時点の全食材」の意味でしかなく、後から追加した あじ は
   * 食べたことが未確認のため、あじ を除いた全食材へ展開する
   *
   * @param tabetakotoaruFoods DB.childのtabetakotoaru_foods キー情報
   */
  expandLegacyTabetakotoaruFoods(tabetakotoaruFoods: string[] = []): string[] {
    if (!tabetakotoaruFoods || !tabetakotoaruFoods.includes("99")) {
      return tabetakotoaruFoods;
    }
    return this.getAllTabetakotoaruFoodKeys()
      .filter((key) => key !== TABETAKOTOARU_FOOD_KEY_AJI);
  }

  /**
   * 「食べたことある」食材の選択値を正規化する
   *
   * 99: すべて食べたことがある は「全選択のショートカット」として扱い、
   * 99 のままでは保存せず、その時点の全食材のキーへ展開する。
   *
   * NOTE: 99 のまま保存すると、後から食材を追加した際に
   *       「実際に食べたことを確認できた食材」が分からなくなるため
   *       (あじ の追加時に、99 登録済みのお子様が未確認のまま
   *        「あじを食べたことがある」扱いになってしまった経緯がある)
   *
   * @param tabetakotoaruFoods DB.childのtabetakotoaru_foods キー情報
   */
  normalizeTabetakotoaruFoods(tabetakotoaruFoods: string[] = []): string[] {
    if (!tabetakotoaruFoods || !tabetakotoaruFoods.includes("99")) {
      return tabetakotoaruFoods;
    }
    return this.getAllTabetakotoaruFoodKeys();
  }

  /**
   * 「食べたことある」離乳食の食材のキーチェックを行う
   *
   * @
   * @param targetKey string ex) "1" "2"
   * @param rinyushokuTabetakotoaruFoods string[]  DB.chiledのrinyushoku_tabetakotoaru_shokuzai キー情報
   *
   */
  isRinyushokuTabetakotoaruFood(targetKey: string, rinyushokuTabetakotoaruFoods: string[] = []) {
    // all: 全て食べたことがあるが 選択されている場合は、全て食べたことにする
    if (rinyushokuTabetakotoaruFoods.includes("all")) {
      return true;
    }
    return rinyushokuTabetakotoaruFoods.find((key) => key === targetKey);
  }

  getHoikuchuFukajikoName(target: string[] = []) {
    if (!target || target.length === 0) return "-";

    if (target.includes && target.includes("99")) {
      return "すべて可";
    }

    const LIST = {
      "1": "バンボ",
      "2": "抱っこひも",
      "3": "おんぶひも",
      "4": "散歩",
      "5": "虫除け",
      "6": "プール(別途料金)",
    };
    return target.map((key) => LIST[key]).join(",");
  }
}



// WEBPACK FOOTER //
// ./src/pages/_com/abstract-page.ts